import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { TimberMaterial, UpdateTimberMaterialBody } from "../../../../http/screwConnector/types/timberMaterials";
import useScrewConnectorTimberMaterialsApi from "../../../../http/screwConnector/useAdminTimberMaterials";
import TimberMaterialForm from "./TimberMaterialForm";

// The inline visibility and order editors re-send the full entity (no /visibility nor /order endpoints).
const toUpdateBody = (item: TimberMaterial): UpdateTimberMaterialBody => ({
  materialCategory: item.materialCategory,
  species: item.species,
  speciesIt: item.speciesIt,
  speciesDe: item.speciesDe,
  speciesEs: item.speciesEs,
  speciesFr: item.speciesFr,
  class: item.class,
  characteristicDensity: item.characteristicDensity,
  meanDensity: item.meanDensity,
  compressionStrength0: item.compressionStrength0,
  compressionStrength90: item.compressionStrength90,
  rollingShearStrength: item.rollingShearStrength,
  shearStrength: item.shearStrength,
  standardReference: item.standardReference,
  visibility: item.visibility,
  order: item.order,
});

const AdminTimberMaterials: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.screwConnectorModule;
  const timberMaterialsApi = useScrewConnectorTimberMaterialsApi();

  return (
    <AdminCrudTable<TimberMaterial>
      filterPrefix="timber_materials"
      useList={timberMaterialsApi.useTimberMaterials}
      head={
        <>
          <TableHeadCell align="left">{t.timberMaterials.fields.materialCategory}</TableHeadCell>
          <TableHeadCell align="left">{t.timberMaterials.fields.species}</TableHeadCell>
          <TableHeadCell align="left">{t.timberMaterials.fields.class}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{t.substrateCategories[item.materialCategory]}</TableCell>
          <TableCell>{item.species ?? "-"}</TableCell>
          <TableCell>{item.class}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          timberMaterialsApi.updateTimberMaterial(item.id, { ...toUpdateBody(item), visibility }),
        updateOrder: (item, order) =>
          timberMaterialsApi.updateTimberMaterial(item.id, { ...toUpdateBody(item), order }),
      }}
      onDelete={(item) => timberMaterialsApi.deleteTimberMaterial(item.id)}
      deleteTitle={t.timberMaterials.singular}
      canAdd
      renderForm={(item, onClose) => <TimberMaterialForm timberMaterial={item} onClose={onClose} />}
    />
  );
};

export default AdminTimberMaterials;
